// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"c87ec510","27":"b93d1c24","147":"f62c9027","150":"5892dcd2","170":"463b46ab","272":"5d39af0e","516":"e4a67104","574":"6c85020d","661":"a010a0d6","919":"1a3e8340"}[chunkId] + ".chunk.js";
};